/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import React from "react";

import { connect } from "react-redux";
import { setAuth, setUser } from "../../redux/actions";
import { useLocation, withRouter } from "react-router-dom";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import LandingPage from "./LandingPage";
import { formFields, services } from "../../configuration/formFields";
import components from "../../configuration/components";
import { getDataFromConfig, loadConfig } from "../../helpers/getDataFromConfig";
import { getEncryptedData } from "../../helpers/tokenHelper";

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	};
};

let configFile = await loadConfig().catch((err) => {
	console.error("Failed to load config:", err);
});

const SignInContainer = (props) => {
	const queryParams = new URLSearchParams(useLocation().search);
	const redirectURI = queryParams.get("redirect_uri");
	const redirectDomain = getDataFromConfig(configFile, redirectURI, "url");
	const siteKey = getDataFromConfig(configFile, redirectURI, "siteKey");
	let email = "";
	let hideRegister =
		String(
			getDataFromConfig(configFile, redirectURI, "register")
		).toLowerCase() === "false";
	let forceRegister;
	if (
		String(
			getDataFromConfig(configFile, redirectURI, "checkParameters")
		).toLowerCase() === "true"
	) {
		const encryptedData = String(queryParams.get("p"));
		if (encryptedData !== "null") {
			const data = getEncryptedData(encryptedData);
			const params = new URLSearchParams(data);
			forceRegister = params.get("forceRegister") === "true";
			if (forceRegister) {
				email = params.get("emailPlaceholder");
			} else {
				hideRegister = !hideRegister;
			}
		}
	}
	const idpToShow =
		getDataFromConfig(configFile, redirectURI, "socialProviders") || [];
	const termsAndConditionsURL =
		getDataFromConfig(configFile, redirectURI, "CLUF") ||
		`${redirectDomain}/home/terms-and-conditions.html`;

	return (
		<Authenticator
			formFields={formFields(props.lang, siteKey, email)}
			services={services}
			hideSignUp={hideRegister}
			components={components(
				redirectDomain,
				hideRegister,
				forceRegister,
				idpToShow,
				termsAndConditionsURL
			)}
		>
			<LandingPage siteKey={siteKey} lang={props.lang} />
		</Authenticator>
	);
};

export default withRouter(
	connect(mapStateToProps, { setAuth, setUser })(SignInContainer)
);
